export default __webpack_public_path__ + "static/media/image-replace.02cc34c1.svg";